// extracted by mini-css-extract-plugin
export default {"waveTop":"Wave_waveTop__j3AIP","waveBottom":"Wave_waveBottom__E54r6"};